var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE__apps_rs_shop_browser_remoteEntry_mjs_6e128a3a__;